import { Link } from 'react-router-dom';

const index = ({
  PathToManifest,
  label,
  classNames,
  detailsPageUrl = undefined,
}) => {
  return (
    <>
      <esp-web-install-button id='installButton' manifest={PathToManifest}>
        <button
          type='button'
          className={'btn btn-info text-white '.concat(classNames)}
          slot='activate'
        >
          <i className='bi bi-upload me-1'></i> {label}
        </button>
        <Link
          to={detailsPageUrl || '!#'}
          type='button'
          className='btn text-dark btn-sm btn-warning'
          slot='unsupported'
        >
          <i className='bi bi-exclamation-diamond-fill me-1'></i> Use Chrome
          Desktop Browser
        </Link>
        <Link
          to={detailsPageUrl || '!#'}
          type='button'
          className='btn text-dark btn-sm btn-danger'
          slot='not-allowed'
        >
          <i className='bi bi-exclamation-triangle-fill me-1'></i> Not Allowed
        </Link>
      </esp-web-install-button>
    </>
  );
};

export default index;
